import { useState, useEffect } from 'react';
import InventoryItemsService from '../../../api/Inventory/InventoryItemsService';
import { PaginationRequest, PaginationResult } from '../../../api/Common/Util';
import useLoading from '../../../components/Common/useLoading';


const propsTemplate = () => ({ ...new PaginationRequest(), search: '', includeStock: false, includeLastEntry: false, protocolId: null, includedTypes: null });

export default function useProtocolItems({ preload = false, requestProps = {} }) {
    const [pagedItems, setPagedItems] = useState(new PaginationResult());
    const [isLoading, doLoad, reload] = useLoading({
        onLoad: async () => {
            if (!preload) return;
            await FindItems({ ...requestProps });
        },
        onError: (error) => setPagedItems(new PaginationResult())
    });

    const Navigation = {
        ToPage: async ({ page }) => doLoad(async () => {
            const request = pagedItems.ToPage(page);

            if (request == null) return;
            await FindItems({ ...requestProps, ...request });
        }),
        Find: async (props = propsTemplate()) => doLoad(async () => {
            const newRequest = { ...requestProps, ...props };
            await FindItems(newRequest);
        }),
        Clear: () => setPagedItems(new PaginationResult()),
        Reload: reload
    };

    async function FindItems(props) {
        const result = await InventoryItemsService.FindProtocolInventory({ ...props });
        result.SortColumn = requestProps.sortColumn
        result.SortOrder = requestProps.sortOrder

        setPagedItems(result);
    }

    return [pagedItems, isLoading, Navigation];
}
